import { MAX_FILE_SIZE } from './Constants';

export const Messages = {
    MERGE_SUCCESS: 'Wordファイルの解析が成功しました。',
    SEARCH_KEYWORD_ADDED: '検索キーワードを追加しました。',
    EXCLUDE_KEYWORD_ADDED: '除外キーワードを追加しました。',

    FILE_UPLOAD_ERROR: 'No.001: ファイル解凍中にエラーが発生しました。',
    FILE_NOT_FOUND_ERROR: 'No.002: XMLファイルが見つかりませんでした。',
    UNSUPPORTED_FILE_FORMAT: 'No.003: サポートしていないファイル形式です。.docxファイルを選択してください。',
    FILE_READ_ERROR: 'No.004: ファイル読み込みエラーが発生しました。',
    FILE_PROCESS_ERROR: 'No.005: ファイル処理エラーが発生しました。エラー内容: ',
    EMPTY_KEYWORD: 'No.006: 空白だけのキーワードは追加できません。',
    DUPLICATE_KEYWORD: 'No.007: このキーワードは既に存在します。',
    MARKDOWN_LOAD_ERROR: 'No.008: マークダウンファイルの読み込みに失敗しました。',
    EXCEL_SHEET_ERROR: 'No.009: DL用のExcelシート名に問題があります。',
    EXCEL_GENERATION_ERROR: 'No.010: Excel生成処理に問題が発生しました。',
    FILE_SIZE_ERROR: `No.011: ファイルサイズが${MAX_FILE_SIZE / 1024 / 1024}MBを超えています。`,
    INVALID_CHARACTER_ERROR: 'No.012: キーワードに使用できない文字が含まれています。',
    DL_EXCEL: '点検結果報告書の様式に検索キーワードを含む条文を転記してダウンロードしました。確認の上、点検対象の該当有無をH列、U列に記載し、点検対象の場合はI列以降、V列以降を記入ください。',
    DL_WORD: '検索キーワードをハイライトしたWordファイルをダウンロードしました。'
};
